import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/api/http';

/**
 * Reads retry once, except when the session ended or the answer had the wrong shape (retrying cannot help).
 * Mutations never retry: a repeated close or add could act twice.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10_000,
      retry: (failureCount, error) => failureCount < 1 && !(error instanceof ApiError && (error.kind === 'unauthorized' || error.kind === 'contract')),
    },
    mutations: { retry: false },
  },
});
